import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has been stable for `delayMs` milliseconds. Used by
 * type-ahead inputs so we don't fire a query keystroke-by-keystroke.
 *
 * Mirrors the inline debounce that used to live in IssuePage / AdjustPage /
 * StockStatusPage — extracting it keeps the timing rule (and its cleanup) in
 * one place.
 */
export function useDebounced<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
